import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon, CheckCircleIcon } from 'lucide-react';
export function SalesLetterSection() {
  const painPoints = ['¿Te has sentido frustrada porque no encuentras opciones REALES para generar ingresos extras desde tu casa... sin tener que depender de un jefe o un horario imposible?', '¿Has querido aprender a hacer jabones artesanales pero no sabes por dónde empezar, qué materiales comprar, ni cuánto de cada cosa usar... y tienes TERROR de desperdiciar tu dinero en ingredientes que terminen en la basura?', '¿Has buscado información en YouTube o Google y encontraste puras recetas incompletas, contradictorias, con medidas que no funcionan y tutoriales que te dejan con MÁS dudas que respuestas?', '¿Has pensado en tomar un curso presencial pero cuando viste que cuesta entre $300 y $500 dólares... simplemente no te alcanza o no justifica el riesgo?', '¿Sueñas con tener tu propio negocio en casa, ser tu propia jefa, generar entre $100 y $500 dólares mensuales extras... pero sientes que no tienes el conocimiento ni la experiencia para dar el primer paso?'];
  const problems = ['Recetas INCOMPLETAS — Les falta un paso, les faltan medidas exactas o dan las cantidades en unidades que nadie entiende.', 'Instrucciones que ASUMEN que ya sabes — Te dicen "agrega la esencia" pero nunca te dicen CUÁNTA.', 'Videos de YouTube bonitos pero INÚTILES — Se ven hermosos, sí. Pero cuando intentas replicarlos, te das cuenta de que omitieron la mitad de los pasos.', 'Cursos presenciales que cuestan una FORTUNA — ¿$300 a $500 dólares por un fin de semana? ¿En serio?', '¡Simplemente NO hay suficiente detalle! — Te dan la receta del jabón más simple... y luego esperan que tú sola descifres todo lo demás.'];
  return <section className="w-full py-16 md:py-24 px-4 bg-white" data-id="element-163">
      <div className="max-w-3xl mx-auto" data-id="element-164">
        {/* Letter Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mb-12 text-center" data-id="element-165">
          <p className="font-inter text-sm text-brown/60 mb-2" data-id="element-166">
            Desde el Escritorio de María Alejandra
          </p>
          <p className="font-playfair text-2xl md:text-3xl font-bold text-terracotta mb-4" data-id="element-167">
            Re: Jabones Artesanales al fin... fáciles, rentables y sin misterio.
          </p>
        </motion.div>

        {/* Opening */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="mb-12" data-id="element-168">
          <p className="font-playfair text-2xl md:text-3xl font-semibold text-brown mb-6" data-id="element-169">
            Querida Emprendedora,
          </p>
          <p className="font-inter text-lg text-brown/80 mb-4" data-id="element-170">
            ¿Alguna vez has...
          </p>
        </motion.div>

        {/* Pain Points */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="mb-12 space-y-4" data-id="element-171">
          {painPoints.map((point, index) => <div key={index} className="flex items-start gap-3 bg-urgency/5 p-4 rounded-lg border-l-4 border-urgency" data-id="element-172">
              <XCircleIcon className="w-6 h-6 text-urgency flex-shrink-0 mt-1" data-id="element-173" />
              <p className="font-inter text-base text-brown/90" data-id="element-174">{point}</p>
            </div>)}
        </motion.div>

        {/* Empathy Statement */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="mb-12 bg-cream p-8 rounded-lg border-2 border-terracotta/30" data-id="element-175">
          <p className="font-inter text-lg text-brown/90 leading-relaxed" data-id="element-176">
            Estos son EXACTAMENTE los mismos problemas que yo enfrenté hace más
            de 10 años cuando empecé en el mundo de los jabones artesanales... y
            son los mismos desafíos que más de 2,500 alumnas me reportan antes
            de conocer mi método.
          </p>
        </motion.div>

        {/* Big Promise */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="mb-12 text-center bg-gradient-to-r from-terracotta to-sage p-8 rounded-xl text-white" data-id="element-177">
          <p className="font-playfair text-3xl md:text-4xl font-bold" data-id="element-178">
            "¡Crear jabones artesanales NO debería ser tan difícil ni tan caro!"
          </p>
        </motion.div>

        {/* Transition */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.5
      }} className="mb-12" data-id="element-179">
          <p className="font-inter text-lg text-brown/90 leading-relaxed mb-6" data-id="element-180">
            Ahora, si quieres crear los jabones artesanales con los que siempre
            has soñado — rápida y fácilmente...
          </p>
          <p className="font-inter text-lg text-brown/90 leading-relaxed mb-6" data-id="element-181">
            En vez de pasar días, semanas o meses buscando recetas sueltas por
            internet... o peor aún, gastar una fortuna en cursos presenciales
            que solo te enseñan lo básico...
          </p>
          <p className="font-inter text-lg text-brown/90 leading-relaxed mb-6" data-id="element-182">
            Y anhelas la satisfacción de crear algo hermoso con tus propias
            manos que además te genere ingresos reales...
          </p>
          <p className="font-playfair text-2xl font-bold text-terracotta" data-id="element-183">
            Entonces esta puede ser la carta más importante que leas en tu
            vida...
          </p>
        </motion.div>

        {/* Author Bio */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.6
      }} className="mb-12 bg-sage/10 p-8 rounded-lg border-2 border-sage/30" data-id="element-184">
          <div className="flex items-start gap-6" data-id="element-185">
            <div className="w-24 h-24 bg-gradient-to-br from-terracotta to-sage rounded-full flex-shrink-0" data-id="element-186"></div>
            <div data-id="element-187">
              <p className="font-playfair text-2xl font-bold text-brown mb-2" data-id="element-188">
                María Alejandra
              </p>
              <p className="font-inter text-sm text-brown/80 leading-relaxed" data-id="element-189">
                Ingeniera Química de profesión, Maestra Jabonera con 10+ años de
                experiencia. Fundadora de "Aprende y Emprende en Casa" — Ha
                ayudado a +2,500 personas en toda Latinoamérica a iniciar su
                negocio de jabones artesanales desde cero.
              </p>
            </div>
          </div>
        </motion.div>

        {/* The Problem Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.7
      }} className="mb-12" data-id="element-190">
          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-brown mb-8 text-center" data-id="element-191">
            "Este Es El GRAN Problema..."
          </h2>
          <p className="font-inter text-lg text-brown/90 mb-6" data-id="element-192">
            Cuando empecé a buscar información sobre jabones artesanales, esto
            es lo que descubrí:
          </p>
          <p className="font-playfair text-2xl font-bold text-urgency mb-6 text-center" data-id="element-193">
            La mayoría de los tutoriales, recetas de internet y cursos de
            jabones son BASURA COMPLETA.
          </p>
          <p className="font-inter text-lg text-brown/90 mb-8" data-id="element-194">
            Y aquí te explico por qué:
          </p>

          <div className="space-y-4" data-id="element-195">
            {problems.map((problem, index) => <div key={index} className="flex items-start gap-3 bg-white p-4 rounded-lg border-l-4 border-urgency shadow-sm" data-id="element-196">
                <XCircleIcon className="w-6 h-6 text-urgency flex-shrink-0 mt-1" data-id="element-197" />
                <p className="font-inter text-base text-brown/90" data-id="element-198">{problem}</p>
              </div>)}
          </div>
        </motion.div>

        {/* Solution Intro */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.8
      }} className="mb-12 text-center" data-id="element-199">
          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-brown mb-6" data-id="element-200">
            Así Que Decidí Resolver Todo Eso De Una Vez Por Todas...
          </h2>
          <p className="font-inter text-lg text-brown/90 leading-relaxed mb-6" data-id="element-201">
            Bueno, por suerte para ti, todos esos problemas se convirtieron en
            una bendición disfrazada.
          </p>
          <p className="font-inter text-lg text-brown/90 leading-relaxed" data-id="element-202">
            Porque he pasado los últimos 10+ años creando la guía más completa,
            detallada y fácil de seguir sobre jabones artesanales que existe en
            español.
          </p>
        </motion.div>
      </div>
    </section>;
}